import { render, staticRenderFns } from "./NoPhoneNumber.vue?vue&type=template&id=b544b312&scoped=true&"
import script from "./NoPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./NoPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./NoPhoneNumber.vue?vue&type=style&index=0&id=b544b312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544b312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
